import * as React from 'react';
// Import react.
import { useParams } from "react-router-dom";
// Import props.
import {
    VersionProps,
} from '@app/props';
// Import hooks.
import {
    useAppRedirect,
} from '@app/hooks/utility';

interface UseVersionPropsFromRouterResult extends VersionProps {

}

const useVersionPropsFromRouter = (): UseVersionPropsFromRouterResult => {
    const { redirect } = useAppRedirect();
    const params = useParams();

    // Parse out the router parameters for policy id.
    const versionId: number | undefined = React.useMemo(() => {
        return isNaN(params['versionId'])
            ? undefined
            : parseInt(params['versionId']);
    }, [params]);

    React.useEffect(() => {
        if (versionId === undefined) {
            redirect();
        }
    }, [versionId]);

    return {
        versionId: versionId ?? -1,
    }
}

// Export results.
export {
    UseVersionPropsFromRouterResult,
}

export default useVersionPropsFromRouter;